import apiClient from '@/services/axios'

export async function patch(venueSetupId, venueSectionId, venueTableId, isActive) {
  var setActiveRequest = {
    active: isActive
  }

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/venue-setups/${venueSetupId}/venue-sections/${venueSectionId}/venue-tables/${venueTableId}`, setActiveRequest);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch venue table active state.');
}
